import React from 'react';
import { Flex, Text, Image, Button } from 'rebass';
import { Notification } from 'types/notifications';
import colors from 'theme/colors';
import { format } from 'date-fns';
import notificationInfo from 'assets/icons/notificationInfo.png';
import useModal from 'hooks/useModal';
import { getNotificationLink } from 'selectors/notifications';
import Link from 'components/Link';

interface NotificationComponentProps {
  notification: Notification;
}

const NotificationComponent: React.FC<NotificationComponentProps> = ({
  notification,
}): JSX.Element => {
  const { openModalHandler } = useModal();
  const notificationLink = getNotificationLink(notification);
  return (
    <Flex justifyContent="space-between" mb={2}>
      <Flex alignItems="center">
        <Flex
          style={{
            width: 10,
            height: 10,
            borderRadius: 5,
            backgroundColor: colors.primary,
            marginRight: 10,
          }}
        />
        {notificationLink ? (
          <Link to={notificationLink}>
            <Text
              color={colors.turquoise}
              fontWeight={notification.status === 'new' ? 'bold' : 'normal'}
              css="text-decoration: underline;"
            >
              {notification.message}
            </Text>
          </Link>
        ) : (
          <Text
            color={colors.turquoise}
            fontWeight={notification.status === 'new' ? 'bold' : 'normal'}
            css="text-decoration: underline;"
          >
            {notification.message}
          </Text>
        )}
        {notification.explanation ? (
          <Button
            bg="transparent"
            px={1}
            py={0}
            css="cursor: pointer;"
            onClick={openModalHandler({ title: 'notification', data: notification })}
          >
            <Image width={18} src={notificationInfo} />
          </Button>
        ) : null}
      </Flex>
      <Text fontWeight={notification.status === 'new' ? 'bold' : 'normal'}>
        {format(notification.createdAt, 'MM.DD.YYYY  h:mma')}
      </Text>
    </Flex>
  );
};

export default NotificationComponent;
